import {
  Alert,
  Badge,
  Button,
  Card,
  Container,
  Flex,
  Group,
  ScrollArea,
  Table,
  Title,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { IconCircleCheck } from "@tabler/icons-react";
import dayjs from "dayjs";
import QueryString from "qs";
import { useState } from "react";
import toast from "react-hot-toast";
import { useSearchParams } from "react-router-dom";
import useSWR from "swr";
import TableEmpty from "@/components/placeholders/TableEmpty";
import RoutePagination from "@/components/RoutePagination";
import useAuthStore from "@/store/useAuthStore";
import { parseMoney } from "@/utils/helpers";
import PointsWithdrawModal from "./PointsWithdrawModal";

export default function Points() {
  const [searchParams, setSearchParams] = useSearchParams();
  const user = useAuthStore((state) => state.user);
  const refetchUser = useAuthStore((state) => state.refetchUser);
  const pageSize = useAuthStore((state) => state.pageSize);
  const page = searchParams.get("page") || 1;

  const form = useForm({
    initialValues: {
      name: "",
    },
  });

  const [sort, setSort] = useState("createdAt:desc");
  const [filters, setFilters] = useState({});

  const params = QueryString.stringify({
    filters: {
      user: user?.id,
      ...filters,
    },
    populate: "*",
    sort: [sort],
    pagination: {
      page,
      pageSize,
    },
  });

  const title = "마일리지 내역";
  const { data, mutate, isLoading } = useSWR(["/point-logs", params]);
  console.log("🚀", data?.data);

  function handleSearch() {
    setSearchParams({ page: 1 });
    let newFilter = {};

    // EDIT FILTERS
    const { name } = form.values;
    if (name) newFilter = { ...newFilter, name: { $contains: name } };

    setFilters(newFilter);
  }

  function handleClearSearch() {
    setSearchParams({ page: 1 });
    form.reset();
    setFilters({});
  }

  function refresh() {
    refetchUser();
    mutate();
    toast.success("마일리지 갱신 완료");
  }

  return (
    <Container fluid>
      <Card>
        <Group mb="sm">
          <Flex gap="xs" align="center">
            <Title order={4}>{title}</Title>
            <Alert icon={<IconCircleCheck size="1rem" />} color="orange" py={6}>
              마일리지는 배차 완료 후 15일 이내에 적립됩니다
            </Alert>
          </Flex>
          <Flex gap="xs">
            <Button onClick={refresh}>마일리지 갱신</Button>
            <PointsWithdrawModal mutate={mutate} />
          </Flex>
        </Group>

        <ScrollArea>
          <Table>
            <thead>
              <tr>
                <th>#</th>
                <th className="tc">상태</th>
                <th className="tc">내용</th>
                <th className="tr">적립/차감 마일리지</th>
                <th className="tr">총 마일리지</th>
                <th className="tc">변동일시</th>
              </tr>
            </thead>
            <tbody>
              {!isLoading && data?.data?.length === 0 && (
                <TableEmpty
                  title="마일리지 내역이 없습니다."
                  text="배차 완료 후 15일 이내에 마일리지가 적립됩니다."
                />
              )}
              {data?.data?.map((row, idx) => {
                const item = row.attributes || {};
                return (
                  <tr key={row.id}>
                    <td>{idx + (page - 1) * pageSize + 1}</td>
                    <td className="tc">
                      {item.amount > 0 ? (
                        <Badge color="teal">적립</Badge>
                      ) : (
                        <Badge color="pink">차감</Badge>
                      )}
                    </td>
                    <td className="tc">{item.reason}</td>
                    <td className="tr">{parseMoney(item.amount)}원</td>
                    <td className="tr">{parseMoney(item.afterAmount)}원</td>
                    <td className="tc">{dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss")}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </ScrollArea>

        <RoutePagination
          total={data?.meta?.pagination?.pageCount}
          page={page}
          setSearchParams={setSearchParams}
        />
      </Card>
    </Container>
  );
}
